// Paper doesn't open folds (FR-VOTE-16): Review folds an item's checks
// unless they changed since the reader's last vote, which would print each
// such item with its count and no check under it. So printing opens every
// item's checks, and once printed closes again those it opened. The
// issue's page does the same with the rest of the issue and its comments
// (FR-URL-14), which are what that page is for. Without JavaScript they
// print folded, as the page shows them.
//
// While it prints, <html> carries `printing`, so the hint above the checks,
// which says they are folded, and the label over the rest of the issue go
// from paper they are open on; paper printed without JavaScript keeps them.

/** Review's folded checks (`ui/collapsed.rs`). */
const CHECKS = "details.collapsed-checks";

/** The rest of the issue on its page (`web/spec/spec_page.rs` body_preview). */
const ISSUE_REST = "details.issue-rest";

/** On <html> from beforeprint to afterprint (app.css's print block). */
const PRINTING = "printing";

/** The folds printing opened, to close again after. */
let opened: HTMLDetailsElement[] = [];

window.addEventListener("beforeprint", () => {
  document.documentElement.classList.add(PRINTING);
  opened = Array.from(
    document.querySelectorAll<HTMLDetailsElement>(
      `${CHECKS}:not([open]), ${ISSUE_REST}:not([open])`,
    ),
  );
  for (const fold of opened) fold.open = true;
});

window.addEventListener("afterprint", () => {
  document.documentElement.classList.remove(PRINTING);
  for (const fold of opened) fold.open = false;
  opened = [];
});
